const writeToSessionStorage = (key, value) => {
    window.sessionStorage.setItem(key, value)
}

const readFromSessionStorage = key => {
    return window.sessionStorage.getItem(key)
}

export { readFromSessionStorage, writeToSessionStorage }